import { useTheme } from '@mui/material/styles';

import useWidth from '../../Hooks/useWidth';

export const useNavBarHeight = (): number => {
  const theme = useTheme();
  const isMobile = useWidth('down', 'sm');

  return isMobile ? 0 : theme.mixins.toolbar['@media (min-width:600px)']?.minHeight;
};
